import { Textarea } from '@mantine/core'

export default {
  Textarea: Textarea.extend({
    styles: (_theme, params) => ({
      input: {
        borderWidth: '2px',
        borderRadius: '8px',
        cursor: params.readOnly ? 'not-allowed' : undefined,
      },
    }),
  }),
}
